import React from 'react';
import { AppContext } from '@/hooks/use-app-context';
var useGetPersonalizationSettingsEntryShow = function useGetPersonalizationSettingsEntryShow() {
  var _React$useContext = React.useContext(AppContext),
    platformConfig = _React$useContext.platformConfig;
  return platformConfig === null || platformConfig === void 0 ? void 0 : platformConfig.isShowRecommendationSettings;
};
export default useGetPersonalizationSettingsEntryShow;